import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { Card, CardContent, Grid, GridColumn, Icon, Separator, Text, Tooltip, TooltipToggle } from 'telia-front-react';

const MeluNetflixOfferCard = observer((): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;

  const existingNetflixAccountTooltip = () => {
    return `<Tooltip referenceElement={<TooltipToggle>${translate('meluCalculator.existingNetflixAccount.tooltipToggle')}</TooltipToggle>}>
          ${translate('meluCalculator.existingNetflixAccount.tooltipContent')}
        </Tooltip>`;
  };

  const createNewAccountTooltip = () => {
    return `<Tooltip referenceElement={<TooltipToggle>${translate('meluCalculator.createNewAccount.tooltipToggle')}</TooltipToggle>}>
          ${translate('meluCalculator.createNewAccount.tooltipContent')}
        </Tooltip>`;
  };

  return (
    <Card background="neutral-bg-level-2">
      <CardContent>
        <Text>
          {translate('meluCalculator.netflixOffers.title', {
            netflixTooltip: existingNetflixAccountTooltip(),
            createNewAccountTooltip: createNewAccountTooltip(),
          })}
          <Separator spacing={'small'} />
          <Grid align={['middle-xs']} verticalGutter="smedium">
            <GridColumn width={['md-6']}>
              <Grid noWrap={true} align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#tv-viewslot" size="md" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <Tooltip
                    referenceElement={<TooltipToggle className="text-small">{translate('meluCalculator.netflixOffers.viewSlots.tooltipToggle')}</TooltipToggle>}
                  >
                    {translate('meluCalculator.netflixOffers.viewSlots.tooltipContent')}
                  </Tooltip>
                </GridColumn>
              </Grid>
            </GridColumn>
            <GridColumn width={['md-6']}>
              <Grid noWrap={true} align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#tv-screen" size="md" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <p className="text-small">{translate('meluCalculator.netflixOffers.4k.text')}</p>
                </GridColumn>
              </Grid>
            </GridColumn>
            <GridColumn width={['md-6']}>
              <Grid noWrap={true} align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#file-bill" size="md" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <p className="text-small">{translate('meluCalculator.additionalOffers.bill.text')}</p>
                </GridColumn>
              </Grid>
            </GridColumn>
          </Grid>
        </Text>
      </CardContent>
    </Card>
  );
});

export default MeluNetflixOfferCard;
